import { signal } from '@preact/signals-react';

interface Transcript {
  id?: string;
  duration?: string;
  datetime?: string;
  asr_model?: string;
}

export const selectedTranscript = signal<Transcript>({
  id: '',
  duration: '',
  datetime: '',
  asr_model: '',
});
